import createReactClass from "create-react-class";

export default function() {
    const html = createReactClass({
        render() {
            return null;
        },
        componentWillReceiveProps(props) {
            setValue(this.props.field, props.globalState);
        },
        componentWillMount() {
            setValue(this.props.field, this.props.globalState);
        }
    });

    return {
        html: html,
        config: {
            invisible: true,
        },
    };
};

function setValue({config, state}, globalState) {
    var {refs} = config;

    var combined = (refs || []).reduce((combined, ref) => {
        const value = (globalState.fullState[ref] || {}).value;
        if (value === undefined) return combined;
        else if (Array.isArray(value)) return [...combined, ...value];
        else return [...combined, value];
    }, []);

    state.value = combined;
}


